export { default } from './SingleChoice.js';
